function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Controlnput } from "../../CommonComponents/ControlInput";
var style = {
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer'
};
export var ControlWeb = function ControlWeb(_ref) {
  var selectProps = _ref.selectProps,
      innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      children = _ref.children;

  var onTouch = function onTouch(e) {
    if (!document.getElementById('customIndicators').contains(e.target)) {
      selectProps.setMenuIsOpen(!selectProps.menuIsOpen);
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-line jsx-a11y/click-events-have-key-events
    ref: innerRef
  }, innerProps, {
    style: style,
    onTouchEnd: onTouch,
    onClick: onTouch
  }), /*#__PURE__*/React.createElement(Controlnput, {
    selectProps: selectProps,
    innerRef: innerRef,
    innerProps: innerProps
  }, children));
};